import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse, HttpParams } from '@angular/common/http';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { catchError } from 'rxjs/operators';
import { throwError, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ClientShowkeyModalService {

  private url: string;

  constructor(private http: HttpClient, public router: Router) {
      this.url = environment.apiUrl;
  }

  /**
   *
   */
  public getClient(clientId: string): Observable<object> {
    return this.http
               .get(`${this.url}/clients/${clientId}`, { responseType: 'json' })
               .pipe(
                 catchError(this.errorHandler)
               );
  }

   /**
   *
   * @param client
   */
  public generateApiKey(clientId: string) {
    const params = new HttpParams()
      .append('clientId', clientId);

    return this.http
               .post(`${this.url}/clients/configuration/apikey/generate`, null, { responseType: 'json', params })
               .pipe(
                catchError(this.errorHandler)
              );
  }

  /**
   *
   * @param error
   */
  private errorHandler(error: HttpErrorResponse) {
    return throwError(error);
  }
}
